/******************************************************
 *                  Carto-iti
 *
 *  Permet d'afficher différentes informations sous
 *  format cartographique
 *
 ********************************************************/

"use strict";

angular.module("carto-iti", []);
